import {
  Input,
  VStack,
  HStack,
  Text,
  StackProps,
} from '@wegroup/design-system';
import React, { ChangeEvent, KeyboardEvent } from 'react';
import EuropeStars from '../../../../assets/images/europe-stars';

interface Props {
  countryCode: string;
  onChange?: (e: ChangeEvent<HTMLInputElement>) => void;
  onKeyPress?: (e: KeyboardEvent<HTMLInputElement>) => void;
  value?: string;
  isDisabled?: boolean;
}

const LicenseInputEU: React.FC<React.PropsWithChildren<Props & StackProps>> = ({
  countryCode,
  onChange,
  onKeyPress,
  value,
  isDisabled,
  ...otherProps // Styling props
}) => {
  return (
    <HStack
      border="2px solid black"
      borderRadius="md"
      overflow="hidden"
      bg="yellow.400"
      height="12"
      maxW="64"
      {...otherProps}
    >
      <VStack
        backgroundColor="blue"
        paddingX="1"
        paddingY="1"
        spacing="1"
        h="100%"
        justifyContent="space-between"
      >
        <EuropeStars size={15} />
        <Text fontWeight="black" color="white">
          {countryCode}
        </Text>
      </VStack>
      <Input
        textTransform="uppercase"
        textAlign="center"
        backgroundColor="transparent"
        border="none"
        fontSize="xl"
        fontWeight="black"
        value={value}
        onChange={onChange}
        onKeyPress={onKeyPress}
        className="LicenseInputEU__Input"
        data-test-id={`COMPONENTS_LICENSE-PLATE-EU_INPUT`}
        isDisabled={isDisabled}
      />
    </HStack>
  );
};

export default LicenseInputEU;
